import { IconContext } from 'react-icons';
import { MenuItem } from './SideMenuModels';
import { NavLink } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';


// Menu Items
import * as MenuSettings from './SideMenuItems';

// Styles
import './SideMenuComponent.css';



export const SideMenuComponent = () => {

  const [t] = useTranslation();

  const Menu = MenuSettings.MenuItems.filter(item => process.env.REACT_APP_PREVIEW_FEATURES !== 'true' ? item.preview === false : item.preview === false || item.preview === true).map((item: MenuItem) => (
    <IconContext.Provider key={item.key} value={{ className: 'menuItemIcon' }}>
      <NavLink key={item.key} to={item.target} className="menuItem" style={{ position: 'relative' }}>
        {item.icon}
        <Trans i18nKey={item.name} />
        {item.badge && (
          <span style={{
            position: 'absolute',
            left: '8px',
            top: '4px',
            fontSize: '8px',
            fontWeight: '700',
            textTransform: 'uppercase',
            padding: '2px 5px',
            borderRadius: '3px',
            backgroundColor: item.badgeColor || '#3b82f6',
            color: '#ffffff',
            letterSpacing: '0.3px',
            lineHeight: '1'
          }}>
            {item.badge}
          </span>
        )}
      </NavLink>
    </IconContext.Provider>
  ));

  return (
    <div className="sideMenuStickyLeft sideMenuBackground">
      <img
        src={require('../../assets/img/logo_alphacr.png')}
        alt="Ichtys"
      ></img>
      {Menu}
    </div>
  );
};
